import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Modèle plan de trésorerie gratuit : téléchargez et adaptez | Trezoone',
    description: 'Modèle de plan de trésorerie prêt à l\'emploi pour association, PME ou TPE. Gratuit, personnalisable, avec instructions détaillées.',
    canonical: '/modele-plan-tresorerie',
    keywords: 'modèle plan trésorerie, modele plan de tresorerie, template trésorerie, tableau trésorerie gratuit, modèle budget trésorerie',
  },
  hero: {
    tag: 'Modèle plan de trésorerie',
    title: 'Un modèle de plan de trésorerie qui s\'adapte à votre structure.',
    subtitle: 'Pas besoin de partir de zéro. Voici la structure d\'un plan de trésorerie efficace — que vous utilisiez Excel ou un outil dédié.',
    ctaLabel: 'Créer mon plan en ligne',
  },
  pilierLink: { label: 'Guide plan de trésorerie', href: '/plan-tresorerie' },
  sections: [
    {
      type: 'explain',
      title: 'Les éléments d\'un bon modèle de plan de trésorerie',
      content: 'Quel que soit votre secteur, votre plan de trésorerie doit couvrir ces éléments :',
      items: [
        'En-tête : nom de la structure, exercice concerné, solde d\'ouverture',
        'Section encaissements : chiffre d\'affaires, subventions, aides, remboursements TVA, autres recettes',
        'Section décaissements : salaires + charges sociales, loyer, fournisseurs, remboursements emprunt, impôts, investissements',
        'Ligne de solde mensuel : encaissements - décaissements',
        'Ligne de solde cumulé : solde précédent + solde mensuel → c\'est ça votre trésorerie réelle',
        'Mise en évidence des mois négatifs (solde cumulé < 0)',
      ],
    },
    {
      type: 'example',
      title: 'Exemple de modèle — PME de services, 6 mois',
      content: 'Solde de départ : 15 000 €. Charges mensuelles fixes : 18 000 €. Délai encaissement client : 45 jours.',
      items: [
        'Janvier : CA facturé 22 000 € / Encaissé 0 € (décalage) / Charges 18 000 € → Solde : -3 000 €',
        'Février : CA facturé 25 000 € / Encaissé 22 000 € (janv.) / Charges 18 000 € → Solde : +4 000 €',
        'Mars : CA facturé 20 000 € / Encaissé 25 000 € (fév.) / Charges + TVA 28 000 € → Solde : +1 000 €',
        'Lecture : même avec un CA correct, le solde de janvier est négatif — à financer à l\'avance',
      ],
    },
    {
      type: 'midcta',
      title: 'Un modèle statique c\'est un point de départ — un plan vivant c\'est ce qui vous protège',
      content: 'Trezoone génère automatiquement votre plan de trésorerie depuis vos données réelles. Plus de saisie manuelle, plus de formules cassées.',
    },
    {
      type: 'solution',
      title: 'Trezoone : votre modèle vivant de plan de trésorerie',
      content: 'Un modèle PDF ou Excel ne se met pas à jour tout seul. Trezoone crée votre plan de trésorerie automatiquement à partir de vos données réelles.',
      items: [
        'Plan généré en quelques minutes à partir de vos relevés bancaires',
        'Ligne par ligne, mois par mois, toujours à jour',
        'Mise en évidence automatique des mois à risque',
        'Export PDF du plan pour vos financeurs ou votre banque',
        'Pas de formule à maintenir, pas de risque d\'erreur',
      ],
    },
    {
      type: 'cluster',
      title: 'Ressources pour construire votre plan de trésorerie',
      links: [
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'Excel trésorerie association', href: '/excel-tresorerie-association' },
        { label: 'Plan trésorerie PME', href: '/plan-tresorerie-pme' },
        { label: 'Tableau trésorerie gratuit', href: '/tableau-tresorerie-gratuit' },
        { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
        { label: 'Excel vs logiciel trésorerie', href: '/excel-vs-logiciel-tresorerie' },
        { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
        { label: 'Simulation trésorerie association', href: '/simulation-tresorerie-association' },
      ],
    },
    {
      type: 'cta',
      title: 'Créez votre plan de trésorerie en ligne',
      content: 'Trezoone génère votre plan automatiquement. Essai gratuit 14 jours, sans carte bancaire.',
    },
  ],
  relatedLinks: [
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'Excel trésorerie association', href: '/excel-tresorerie-association' },
    { label: 'Plan trésorerie PME', href: '/plan-tresorerie-pme' },
    { label: 'Tableau trésorerie gratuit', href: '/tableau-tresorerie-gratuit' },
    { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
    { label: 'Excel vs logiciel trésorerie', href: '/excel-vs-logiciel-tresorerie' },
    { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
    { label: 'Simulation trésorerie association', href: '/simulation-tresorerie-association' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function ModelePlanTresoreriePage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
